"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.kLayerPatched = void 0;
/**
 * This symbol is used to mark a Koa layer as being already instrumented
 * since its possible to use a given layer multiple times (ex: middlewares)
 */
exports.kLayerPatched = Symbol('koa-layer-patched');
//# sourceMappingURL=internal-types.js.map